import ActionButton from 'components/ActionButton';
import { func, object, string } from 'prop-types';
import { path } from 'ramda';
import React from 'react';

import ContentColumns from '../../components/ContentColumns';
import ControlSteps from '../../components/ControlSteps';
import NeurologistText from './NeurologistText';

const View1 = ({ advanceView, neurologistsComments }, { fmString, formValues, onChange }) => {
  const nearFutureTarget = path(['rehab5', 'nearFutureTarget'], formValues);
  const plannedChangesToManageCognitiveProblems = path(
    ['rehab5', 'plannedChangesToManageCognitiveProblems'],
    formValues,
  );

  const onChangeFollowed = followed => () => {
    onChange({ followedPlan: followed });
    advanceView();
  };

  return (
    <React.Fragment>
      <ContentColumns
        firstColumn={
          <div>
            <h2>{fmString('onlineRehabilitation.rehab6.1.welcome')}</h2>
            <br />
            <div>{fmString('onlineRehabilitation.rehab6.1.text1')}</div>
            <ControlSteps steps={{ nearFutureTarget: nearFutureTarget }} cognition fm={fmString} />
            <br />
            <div>{fmString('onlineRehabilitation.rehab6.1.text2')}</div>
            <ul>
              {Array.isArray(plannedChangesToManageCognitiveProblems) &&
                plannedChangesToManageCognitiveProblems.map((p, i) => <li key={p + i}>{p}</li>)}
            </ul>
            <br />
            <div>{fmString('onlineRehabilitation.rehab6.1.text3')}</div>
            <br />

            <NeurologistText text={neurologistsComments} />

            <br />
            <h3>{fmString('onlineRehabilitation.rehab6.1.question')}</h3>
            <br />
            <div style={{ display: 'flex' }}>
              <ActionButton
                localeId="onlineRehabilitation.no"
                onClick={onChangeFollowed(false)}
                border
                secondary
                style={{ height: '3.5rem', marginRight: '2rem' }}
              />
              <ActionButton
                localeId="onlineRehabilitation.yes"
                onClick={onChangeFollowed(true)}
                filledSecondary
                style={{ height: '3.5rem' }}
              />
            </div>
          </div>
        }
      />
    </React.Fragment>
  );
};

View1.contextTypes = {
  fmString: func,
  formValues: object,
  onChange: func,
};
View1.propTypes = {
  advanceView: func,
  neurologistsComments: string,
};

export default View1;
